// extracted by mini-css-extract-plugin
export default {"fullPage":"FullPageLoader_fullPage__-Y5ab","icon":"FullPageLoader_icon__E6GCJ"};